import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios'
//import VueAxios from 'vue-axios'

axios.defaults.baseURL = 'https://internal.api.frontcore.com';
// axios.defaults.baseURL = 'http://evaluation.frontcore.test:8081'; //use this for local development
// axios.defaults.baseURL = 'https://staging4.api.frontcore.com';
// axios.defaults.baseURL = 'https://staging2.api.frontcore.com';

import VueRouter from 'vue-router';
import { router } from './routes.js';
Vue.use(VueRouter);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
//VueCookies.set('registration_completed', false); //Debug: reset the cookie value to show form.

import { VueStars } from "vue-stars"
Vue.component("vue-stars", VueStars);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import Vuetify from 'vuetify';
Vue.use(Vuetify);

import PhrasePlugin from './plugins/PhrasePlugin';
Vue.use(PhrasePlugin, {
    baseUrl:  axios.defaults.baseURL,
    dictionary: {},
    init: true, // Load phrases when created
    defaultLanguage: 'en', //We fallback for english for now...
    language: 'sv-SE'
});

Vue.config.productionTip = false;
Vue.router = router;


new Vue({
    render: h => h(App),
    router,
}).$mount('#app');



